/* Shared route checker. All route selections must occur in each pack's live coverage. */
(function () {
  if (customElements.get('tsa-regional-picker')) return;
  function init(root) {
    if (root.dataset.regionalReady) return;
    root.dataset.regionalReady = 'true';
    var selected = new Set(), names = new Map();
    var disclosure = root.querySelector('.tsa-regional-picker__options');
    if (!root.classList.contains('tsa-regional-picker--compact')) {
      var mobile = window.matchMedia('(max-width: 700px)');
      var syncDisclosure = function () { disclosure.open = !mobile.matches; };
      syncDisclosure();
      // Respect native user toggles within a breakpoint; reset only when crossing it.
      mobile.addEventListener('change', syncDisclosure);
    } else {
      disclosure.open = true;
    }
    var search = root.closest('.tsa-pg-wrap[id]');
    var searchInput = search && search.querySelector('[data-pg-filter]');
    var query = searchInput ? searchInput.value.trim().toLowerCase() : '';
    var cards = Array.from(root.querySelectorAll('[data-regional-card]')).map(function (el) {
      var coverage;
      try { coverage = JSON.parse(el.dataset.coverage); } catch (e) { coverage = []; }
      if (!Array.isArray(coverage)) coverage = [];
      var codes = new Set();
      coverage.forEach(function (place) {
        if (!place || !place.code || !place.name) return;
        var code = String(place.code).toUpperCase();
        codes.add(code); names.set(code, ({ CN: 'Mainland China', HK: 'Hong Kong', MO: 'Macau' })[code] || String(place.name));
      });
      return { el: el, codes: codes, title: el.dataset.title, haystack: (el.dataset.title + ' ' + Array.from(codes).map(function (code) { return names.get(code); }).join(' ')).toLowerCase() };
    });
    var options = root.querySelector('[data-regional-options]');
    Array.from(names).sort(function (a, b) { return a[1].localeCompare(b[1]); }).forEach(function (pair) {
      var label = document.createElement('label');
      var input = document.createElement('input');
      input.type = 'checkbox'; input.value = pair[0];
      var span = document.createElement('span');
      var flag = document.createElement('img'); flag.src = root.dataset.flagTemplate.replace('-jp.svg', '-' + pair[0].toLowerCase() + '.svg'); flag.alt = ''; flag.width = 22; flag.height = 22; flag.loading = 'lazy';
      flag.addEventListener('error', function () { flag.remove(); });
      span.append(flag, document.createTextNode(pair[1]));
      label.append(input, span); options.append(label);
      input.addEventListener('change', function () {
        if (input.checked) selected.add(input.value); else selected.delete(input.value);
        update();
      });
    });
    function update() {
      var stops = Array.from(selected), shown = 0;
      var routeMatches = cards.filter(function (card) { return stops.every(function (code) { return card.codes.has(code); }); });
      cards.forEach(function (card) {
        var matches = routeMatches.indexOf(card) !== -1 && (!query || card.haystack.indexOf(query) !== -1);
        card.el.hidden = !matches;
        // Remove display styles from a preceding collection search implementation.
        card.el.style.removeProperty('display');
        if (matches) shown++;
        var match = card.el.querySelector('[data-regional-match]');
        match.hidden = !stops.length;
        match.textContent = 'Covers all ' + stops.length + ' selected ' + (stops.length === 1 ? 'destination' : 'destinations');
      });
      var status = root.querySelector('[data-regional-status]');
      status.textContent = shown + (shown === 1 ? ' regional pack' : ' regional packs') + (stops.length ? ' cover' + (shown === 1 ? 's' : '') + ' your whole route' : ' available') + (query ? ' matching your search.' : '.');
      root.querySelector('[data-regional-clear]').hidden = !stops.length;
      var empty = root.querySelector('[data-regional-empty]');
      empty.hidden = shown !== 0;
      var missing = root.querySelector('[data-regional-missing]'); missing.replaceChildren();
      var noRoute = stops.length && !routeMatches.length;
      empty.querySelector('h3').textContent = noRoute ? 'No single pack covers all your stops' : 'No regional pack matches your search';
      root.querySelector('[data-regional-empty-copy]').textContent = noRoute ? 'These are the destinations each pack is missing.' : 'Try a different search or clear your selected destinations.';
      if (noRoute) cards.forEach(function (card) {
        var li = document.createElement('li');
        li.textContent = card.title + ': missing ' + stops.filter(function (code) { return !card.codes.has(code); }).map(function (code) { return names.get(code); }).join(', ');
        missing.append(li);
      });
      if (search) {
        var count = search.querySelector('[data-target="packs"] .tsa-pg-count');
        if (count) count.textContent = shown;
      }
    }
    root.querySelector('[data-regional-clear]').addEventListener('click', function () {
      selected.clear(); options.querySelectorAll('input').forEach(function (input) { input.checked = false; }); update();
    });
    root.addEventListener('tsa:regional-search', function (event) { query = String(event.detail.query || '').toLowerCase(); update(); });
    update();
  }
  customElements.define('tsa-regional-picker', class extends HTMLElement {
    connectedCallback() { init(this); }
  });
})();
